import withStyles from "@mui/styles/withStyles";
import React from "react";
import { useQuery } from "@apollo/client";
import { GET_AVAILABLE_FEEDS } from "../../queries/queries";
import Error from "../error";
import Loading from "../loading";
import NewsFeed from "./NewsFeed";
import useMakeScrollable from "../../custom_hooks/make-scrollable";
import { useHistory } from "react-router-dom";

const styles = () => ({
  root: {
    fontFamily: "Montserrat",
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
});

function NewsFeedsList() {
  const { loading, error, data } = useQuery(GET_AVAILABLE_FEEDS, { fetchPolicy: "no-cache" });
  const history = useHistory();
  useMakeScrollable();

  if (loading) return <Loading />;
  if (error) return <Error />;

  const feeds = (data?.availableFeeds ?? []).slice().sort((a, b) => {
    const aNum = a.sequenceNumber ?? 0;
    const bNum = b.sequenceNumber ?? 0;
    return aNum - bNum;
  });

  const goToFeed = (id) => history.push(`/news/${id}`);

  return (
    <div className="news-screen">
      <div className="news-header">Dein News-Feed</div>

      <div className="news-sources-viewport">
        <div className="news-sources-track">
          {feeds.map((f) => (
            <button
              key={f.id}
              className="news-source"
              onClick={() => goToFeed(f.id)}
              aria-label={f.name}
              title={f.name}
            >
              <span className="news-source-ring">
                <img src={f.logoUrl} alt={f.name} />
              </span>
            </button>
          ))}
        </div>
      </div>

      <div className="news-list">
        {feeds.map((feed, index) => (
          <NewsFeed
            index={index + 1}
            key={feed.id}
            id={feed.id}
            name={feed.name}
            description={feed.description}
            logo={feed.logoUrl}
          />
        ))}

        <div className="feed-disclaimer">
          <p className="feed-warning">
            „Unter der Rubrik „RSS-Feeds“ sind ausschließlich automatisiert aktualisierte RSS-Feeds
            und Inhalte von fremden Drittplattformen verlinkt. aposphäre ordnet und prüft diese Inhalte
            nicht und übernimmt keine Gewähr für deren inhaltliche und rechtliche Qualität. Von etwaigen
            rechtsverletzenden, diskriminierenden oder politischen Inhalten distanzieren wir uns ausdrücklich.“
          </p>
        </div>
      </div>
    </div>
  );
}

export default withStyles(styles)(NewsFeedsList);
